import {
  TABLE_MANAGEMENT_SERVICE_URL,
  ADD_SUBSCRIPTION
} from './constants'

import {SYNC_BILL_SERVICE_URL} from 'api/syncBill/constants'

import {
  serviceAccountErrorCallback,
  serviceAccountSuccessCallback
} from 'api/callbacks'

export function getGroupSummary () {
  return { data: {total_pages: 1, total_items: 50} }
}

export function getTableGroups (params) {
  return axios.get(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function getTableGroup (id, params) {
  return axios.get(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${id}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function editTableGroup (id, data, params) {
  return axios.put(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${id}`, data, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function createTableGroup (data, params) {
  return axios.post(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups`, data, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function deleteTableGroup (id, params) {
  return axios.delete(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${id}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function duplicateTableGroup (id, params) {
  return axios.post(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${id}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

// Map
export function getTableGroupTables (groupId, params) {
  return axios.get(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${groupId}/tables`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function editTableGroupTable (groupId, tableId, data, params) {
  return axios.put(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${groupId}/tables/${tableId}`, data, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function deleteTableGroupTable (groupId, tableId, params) {
  return axios.delete(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${groupId}/tables/${tableId}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function addTableGroupTable (groupId, data, params) {
  return axios.post(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${groupId}/tables`, data, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function saveTableGroupTables (groupId, data, params) {
  return axios.put(`${TABLE_MANAGEMENT_SERVICE_URL}/table-groups/${groupId}/tables`, data, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function addSubscription () {
  return axios
    .put(ADD_SUBSCRIPTION, {
      feature_name: 'Table Management'
    }, { withCredentials: true })
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let errorObj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          errorObj = new Error(data.errors)
        } else if (data.message) {
          errorObj = new Error(data.message)
        } else {
          errorObj = new Error(error.message)
        }
      } else {
        errorObj = new Error(error.message)
      }
      return Promise.reject(errorObj)
    })
}

export function getReportSummary () {
  return { data: {total_pages: 1, total_items: 50} }
}

export function getTableReports (outletId, params) {
  params = { ...params, sort: 'updatedAt,desc' }
  return axios.get(`${SYNC_BILL_SERVICE_URL}/bills/outlet/${outletId}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function getTableReportSummary (outletId, params) {
  return axios.get(`${SYNC_BILL_SERVICE_URL}/bills/outlet/${outletId}/summary`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}

export function getTableReport (id, outletId, params) {
  return axios.get(`${SYNC_BILL_SERVICE_URL}/bills/outlet/${outletId}/bill/${id}`, {params, withCredentials: false})
    .then(serviceAccountSuccessCallback)
    .catch(serviceAccountErrorCallback)
}



// WEBPACK FOOTER //
// ./app/api/tableManagement/tableManagement.js